export default "__VITE_ASSET__0V547qPn__"